import {
  Circle1,
  CircularProgress1,
  Timer1Background,
  Timer1Blind,
  Timer1BlindWrapper,
  Timer1InfoWrapper,
  Timer1LeftItemWrapper,
  Timer1LeftWrapper,
  Timer1NextBlind,
  Timer1Notice,
  Timer1PrizeItem,
  Timer1PrizeItemTop3,
  Timer1PrizeListWrapper,
  Timer1PrizeWrapper,
  Timer1TimerBox,
  Timer1TimeWrapper,
  UserTimeWrapper1,
} from "./styles/vertical";
import { calculatePercentage, formatNumber } from "../../../utils/timer";
import AdVideo from "../../../component/AdVideo";
import VerticalTimerPrizeBox from "../component/vertical-prize-box";
import { useClock } from "../hooks/use-clock";
import { Helmet } from "react-helmet";

const UserVerticalTimer2 = () => {
  const radius = 491;
  const circumference = 2 * Math.PI * radius;

  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    visibleRanks,
    getNextBlind,
    getNowBlind,
    getData,
    subPrizeFont,
  } = useClock();

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <UserTimeWrapper1>
        {backgroundImage && (
          <Timer1Background backgroundImage={backgroundImage} />
        )}
        <Timer1TimeWrapper>
          <Circle1
            break={
              timeInfo.currentLevel?.type === "BREAK" &&
              timeInfo.elapsedTimeMs &&
              timeInfo.elapsedTimeMs > 0
                ? true
                : false
            }
          >
            <circle className="background" r={492} cx="506" cy="506" />
            <circle
              className="progress"
              r={492}
              cx="506"
              cy="506"
              strokeDasharray={circumference}
              strokeDashoffset={
                timeInfo.currentLevel &&
                timeInfo.remainingTimeInCurrentLevelMs &&
                timeInfo.elapsedTimeMs &&
                timeInfo.elapsedTimeMs > 0
                  ? circumference -
                    (timeInfo.remainingTimeInCurrentLevelMs /
                      (timeInfo.currentLevel?.time * 60000)) *
                      circumference
                  : 0
              }
            />
          </Circle1>
          <div className="dash-wrapper">
            <img
              src={
                timeInfo.currentLevel?.type === "LEVEL" &&
                timeInfo.elapsedTimeMs &&
                timeInfo.elapsedTimeMs > 0
                  ? "/image-web/timer/dash-progress.png"
                  : "/image-web/timer/break-dash-progress.png"
              }
              alt="dash"
            />
            <CircularProgress1
              progress={
                timeInfo.currentLevel && timeInfo.remainingTimeInCurrentLevelMs
                  ? calculatePercentage(
                      timeInfo.remainingTimeInCurrentLevelMs,
                      timeInfo.currentLevel?.time * 60000,
                    ) - 0.4
                  : 0
              }
            />
          </div>
          <Timer1TimerBox>
            <div className="title-box">
              <div className="pub-name">{pub?.cafeName}</div>
              <div className="header">
                {coverImage && <img src={coverImage} alt="logo" />}
                <div className="info-row">
                  <div className="title">{data?.title}</div>
                  <div className="type">{data?.subTitle}</div>
                </div>
              </div>
            </div>
            <div className="level-break">
              <div
                className={`now-level ${
                  timeInfo.currentLevel?.type === "BREAK" && "break "
                }`}
              >{`${
                timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs > 0
                  ? timeInfo.currentLevel?.type === "LEVEL"
                    ? "현재 " + timeInfo.currentLevel.level + "LV"
                    : "BREAK"
                  : "시작 준비중"
              }`}</div>
            </div>
            <div
              className={`time ${
                timeInfo.currentLevel?.type === "LEVEL" &&
                timeInfo?.elapsedTimeMs &&
                timeInfo?.elapsedTimeMs > 0 &&
                "level "
              }`}
            >
              {timeInfo.remainingTimeInCurrentLevel}
            </div>
          </Timer1TimerBox>
          <Timer1BlindWrapper>
            <Timer1Blind>
              <div className="title">NOW BLINDS</div>
              <div className="value">
                <div className="blind">{getNowBlind()}</div>
              </div>
            </Timer1Blind>
            <Timer1NextBlind>
              <div className="title next">NEXT BLINDS</div>
              <div className="value">
                <div className="blind next">{getNextBlind()}</div>
              </div>
            </Timer1NextBlind>
          </Timer1BlindWrapper>
        </Timer1TimeWrapper>
        <Timer1InfoWrapper>
          <Timer1LeftWrapper>
            <Timer1LeftItemWrapper>
              <div className="title">PLAYERS</div>
              <div className="value">{`${userCount} / ${
                adOnUserCount + reBuyInUserCount + entryUserCount
              }`}</div>
            </Timer1LeftItemWrapper>
            <Timer1LeftItemWrapper>
              <div className="title">TOTAL TIME</div>
              <div className="value">{timeInfo.elapsedTime}</div>
            </Timer1LeftItemWrapper>
            <Timer1LeftItemWrapper>
              <div className="title">TOTAL STACKS</div>
              <div className="value">{formatNumber(stack)}</div>
            </Timer1LeftItemWrapper>
            <Timer1LeftItemWrapper>
              <div className="title">AVG STACKS</div>
              <div className="value">{formatNumber(avgStack)}</div>
            </Timer1LeftItemWrapper>
            <Timer1LeftItemWrapper>
              <div className="title">NEXT BREAK</div>
              <div className="value">{timeInfo.timeUntilNextBreak}</div>
            </Timer1LeftItemWrapper>
          </Timer1LeftWrapper>
          <Timer1PrizeWrapper>
            <Timer1PrizeListWrapper>
              <div className="title">PRIZE POOL</div>
              <div className="list-wrapper">
                {data?.moneyInChip.map((item: any, index: number) =>
                  index < 3 ? (
                    <Timer1PrizeItemTop3>
                      <div className={`rank`}>{`${index + 1}${
                        index === 0
                          ? "st"
                          : index === 1
                            ? "nd"
                            : index === 2
                              ? "rd"
                              : "th"
                      }`}</div>
                      <VerticalTimerPrizeBox
                        subPrizeFont={subPrizeFont}
                        data={data}
                        item={item}
                        index={index}
                      />
                    </Timer1PrizeItemTop3>
                  ) : (
                    visibleRanks.includes(index + 1) && (
                      <Timer1PrizeItem length={data?.moneyInChip.length}>
                        <div className={`rank`}>{`${index + 1}${
                          index === 0
                            ? "st"
                            : index === 1
                              ? "nd"
                              : index === 2
                                ? "rd"
                                : "th"
                        }`}</div>
                        <VerticalTimerPrizeBox
                          subPrizeFont={subPrizeFont}
                          data={data}
                          item={item}
                          index={index}
                        />
                      </Timer1PrizeItem>
                    )
                  ),
                )}
              </div>
            </Timer1PrizeListWrapper>
            <Timer1Notice
              dangerouslySetInnerHTML={{
                __html: data?.notice
                  ? data.notice.replace(/\n/g, "<br />")
                  : "",
              }}
            />
          </Timer1PrizeWrapper>
        </Timer1InfoWrapper>
        {isAd && (
          <AdVideo
            coverImage={coverImage}
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </UserTimeWrapper1>
    </>
  );
};
export default UserVerticalTimer2;
